import { observable } from 'mobx';
import Video from '@src/components/video';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

class MainKvStore {
  @observable config = {};
  @observable isActive = false;
  @observable stage = 'appointment'; // appointment-预约 pre_download-预下载 bate-正式
  @observable subscribeTotal = 0;
  @observable kvInfo = {};
  @observable downloadUrl = {};
  @observable template = 'left';

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  formatNumber = num => {
    if (!num) {
      return '0';
    } else {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  openAppointmentModal = () => {};

  openVideo = () => {
    $$tracker.clickKvVideo();
    if (!this.kvInfo.video) {
      return;
    }
    Video.append({ src: this.kvInfo.video });
  };

  use() {}
}
export default MainKvStore;
